import { render, staticRenderFns } from "./ProxyInfo.vue?vue&type=template&id=2f761864&scoped=true&"
import script from "./ProxyInfo.vue?vue&type=script&lang=ts&"
export * from "./ProxyInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyInfo.vue?vue&type=style&index=0&id=2f761864&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f761864",
  null
  
)

export default component.exports